import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";

import {
  GetGendersThunk,
  GetLanguagesThunk,
  GetProfileTypesThunk,
  GetSubjectsThunk,
} from "../redux/thunk";
import type { MasterDataReducer } from "../ts";

const initialState: MasterDataReducer = {
  subjects: undefined,
  genders: undefined,
  profile_types: undefined,
  languages: undefined,
  // is_loading: false,
  error: null,
};

export const masterDataSlice = createSlice({
  name: "master_data",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        isPending(
          GetSubjectsThunk,
          GetLanguagesThunk,
          GetGendersThunk,
          GetProfileTypesThunk
        ),
        () => {
          // state.is_loading = true;
        }
      )
      .addMatcher(
        isRejected(
          GetSubjectsThunk,
          GetLanguagesThunk,
          GetGendersThunk,
          GetProfileTypesThunk
        ),
        () => {
          // state.is_loading = false;
          // state.error = action.payload as ErrorsFromBackendType;
        }
      )
      .addMatcher(isFulfilled(GetSubjectsThunk), (state, action) => {
        // state.is_loading = false;
        state.subjects = action.payload;
      })
      .addMatcher(isFulfilled(GetLanguagesThunk), (state, action) => {
        // state.is_loading = false;
        state.languages = action.payload;
      })
      .addMatcher(isFulfilled(GetGendersThunk), (state, action) => {
        // state.is_loading = false;
        state.genders = action.payload;
      })
      .addMatcher(isFulfilled(GetProfileTypesThunk), (state, action) => {
        // state.is_loading = false;
        state.profile_types = action.payload;
      });
  },
});

export const masterDataActions = masterDataSlice.actions;

export default masterDataSlice.reducer;
